import api from "@/api";


//列表
export const notelist = (data) => {
    return api.axss("post", `/ocm-admin/notice/listPage`, data)
}


//新增
export const noteadd = (data) => {
    return api.axss("post", `/ocm-admin/notice/add`, data)
}

//编辑
export const noteedit = (data) => {
    return api.axss("post", `/ocm-admin/notice/edit`, data)
}

//公告发布和取消发布：新的接口
export const notptoptop= (data) => {
    return api.axss("post", `/ocm-admin/notice/setTopState`, data)
}

//公告发布和取消发布：新的接口
export const notpublish= (data) => {
    return api.axss("post", `/ocm-admin/notice/publish`, data)
}